// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!../../../../breakpoints.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-structures-detail_boxOuter__ldeO6 {
    margin: auto 0 auto auto;
}

.main-structures-detail_fundTitle__EUfsr {
    color: var(--dark-grey);
    margin-bottom: 8px;
}

.main-structures-detail_fundTitleFN__\\+o4UT {
    margin: 5px 0 10px 0;
}

.main-structures-detail_box__NTyAq {
    width: 100%;
    width: 370px;
    min-width: 320px;
    padding: 30px 10px 30px 20px;
    background: #fbfbfc;
    border-radius: 6px;
    border: 4px double rgba(12, 59, 141, 0.25);
    position: relative;
    margin: auto;
}

.main-structures-detail_closeBtnWrapper__6kiol {
    position: absolute;
    height: 25px;
    width: 25px;
    right: 14px;
    top: 8px;
}

.main-structures-detail_closeBtnWrapper__6kiol button {
    height: 25px;
    width: 25px;
    padding: 0;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid var(--primary-color);
    transition: background 0.4s;
    --icon-color-custom: var(--primary-color);
}

.main-structures-detail_closeBtnWrapper__6kiol button:hover {
    background: var(--primary-color);
    border-color: var(--primary-color);
    --icon-color-custom: #fff;
    /*--icon-fill-color-custom: var(--primary-color-active);*/
}

.main-structures-detail_closeBtnWrapper__6kiol button * {
    height: 14px;
    width: 14px;
    padding: 0;
    /*display: block;*/
    /*min-height: 25px;*/
    /*min-width: 25px;*/
}

.main-structures-detail_fieldHeader__oL4\\+0 {
    display: flex;
    align-items: center;
    height: 17px;
    color: var(--dark-grey);
    margin-bottom: 8px;
    text-wrap: nowrap;
}

.main-structures-detail_footnote__hfRpO {
    display: inline;
    vertical-align: super;
    font-size: 8px;
    padding-bottom: 10px;
    font-weight: 400;
}

.main-structures-detail_fieldHeader__oL4\\+0 .main-structures-detail_tip__IFJRB {
    margin: auto auto auto 4px;
}

.main-structures-detail_tip__IFJRB {
    display: inline-flex;
    position: relative;
    justify-content: center;
    padding-left: 4px;
    margin: auto 0 auto auto;
    color: #fff;
    font-size: 14px;
    line-height: 18px;
    text-transform: initial;
    font-weight: 300;
}

.main-structures-detail_tipBtn__WSrI1 {
    background: transparent;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0;
    border: 0;
    color: #000000;
    font-size: 14px;
    margin: auto;
}

.main-structures-detail_tipBtnImg__Gcrx\\+ {
    position: relative;
    display: inline-flex;
}

.main-structures-detail_tipBtn__WSrI1 img:last-child {
    position: absolute;
    bottom: 0;
    opacity: 0;
}

.main-structures-detail_tipBtn__WSrI1 img {
    width: 20px;
    transition: opacity 0.4s;
}

.main-structures-detail_tipSmaller__NooiI .main-structures-detail_tipBtn__WSrI1 img {
    width: 17px;
}

.main-structures-detail_tipBtn__WSrI1 span:first-letter {
    text-transform: capitalize;
}

.main-structures-detail_tip__IFJRB:hover img {
    opacity: 1;
}

.main-structures-detail_tip__IFJRB:hover svg text {
    fill: #fff;
}

.main-structures-detail_tip__IFJRB:hover .main-structures-detail_tipBox__Mw33Y {
    opacity: 1;
    pointer-events: all;
    z-index: 99;
}

.main-structures-detail_tipBox__Mw33Y {
    position: absolute;
    width: 275px;
    background: #7b848e;
    padding: 20px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
    color: #fff;
    font-size: 14px;
    line-height: 18px;
    margin: auto;
    left: 50%;
    transform: translateX(-50%);
    bottom: 24px;
    opacity: 0;
    transition: opacity 0.4s;
    pointer-events: none;
    max-height: 200px;
    overflow: auto;
    z-index: -1;
    text-align: center;
}

.main-structures-detail_tipBox__Mw33Y:first-letter {
    text-transform: capitalize;
}

.main-structures-detail_data__zPtg8 {
    display: grid;
    row-gap: 15px;
    column-gap: 10px;
    grid-template-columns: repeat(2, 1fr);
    margin-top: 15px;
}

.main-structures-detail_borderData__bOqPt {
    display: grid;
    column-gap: 10px;
    grid-template-columns: repeat(2, 1fr);
    padding-top: 8px;
    padding-bottom: 8px;
}

.main-structures-detail_borderData__bOqPt:not(:last-child) {
    border-bottom: 0.5px solid #707070;
}

.main-structures-detail_borderDataTop__e0E5u {
    display: grid;
    column-gap: 10px;
    grid-template-columns: repeat(2, 1fr);
    padding-top: 8px;
    border-top: 0.5px solid #707070;
    margin-top: 15px;
}

.main-structures-detail_borderDataTop__e0E5u h6 {
    color: var(--dark-grey);
}

.main-structures-detail_check__csKOi {
    display: flex;
    margin: 2px 0;
    border: 1px solid #7b848e;
    width: 20px;
    min-width: 20px;
    height: 20px;
    border-radius: 3px;
    transition: background-color 0.4s;
}

.main-structures-detail_check__csKOi.main-structures-detail_active__38qFv {
    background: #fff;
}

.main-structures-detail_check__csKOi.main-structures-detail_active__38qFv:after {
    content: '';
    display: block;
    margin: 3px auto auto;
    width: 4px;
    height: 8px;
    transform: rotate(45deg);
    border-bottom: 1px solid var(--primary-color);
    border-right: 1px solid var(--primary-color);
}

.main-structures-detail_data__zPtg8,
.main-structures-detail_borderData__bOqPt,
.main-structures-detail_borderDataTop__e0E5u {
    grid-template-columns: 150px 1fr;
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]} {
    .main-structures-detail_box__NTyAq {
        padding: 30px 10px;
        width: 320px;
    }

    /*.data {*/
    /*    column-gap: 5px;*/
    /*}*/

    .main-structures-detail_data__zPtg8,
    .main-structures-detail_borderDataTop__e0E5u {
        margin-top: 16px;
    }

    .main-structures-detail_fundTitleFN__\\+o4UT {
        margin-bottom: 16px;
    }

    .main-structures-detail_data__zPtg8,
    .main-structures-detail_borderData__bOqPt,
    .main-structures-detail_borderDataTop__e0E5u {
        grid-template-columns: 120px 1fr;
        row-gap: 16px;
    }

    .main-structures-detail_fieldHeader__oL4\\+0,
    .main-structures-detail_fundTitle__EUfsr {
        margin-bottom: 5px;
    }

    /*.closeBtnWrapper svg {*/
    /*    height: 14px;*/
    /*    width: 14px;*/
    /*}*/
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-sm-max"]} {
    .main-structures-detail_data__zPtg8,
    .main-structures-detail_borderData__bOqPt,
    .main-structures-detail_borderDataTop__e0E5u {
        grid-template-columns: 120px 1fr;
        row-gap: 10px;
    }

    .main-structures-detail_data__zPtg8,
    .main-structures-detail_borderDataTop__e0E5u {
        margin-top: 8px;
    }

    .main-structures-detail_borderData__bOqPt {
        padding-top: 5px;
        padding-bottom: 5px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/LegalStructures/components/MainStructuresDetail/main-structures-detail.module.css"],"names":[],"mappings":"AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,4BAA4B;IAC5B,mBAAmB;IACnB,kBAAkB;IAClB,0CAA0C;IAC1C,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,WAAW;IACX,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sCAAsC;IACtC,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;IACI,gCAAgC;IAChC,kCAAkC;IAClC,yBAAyB;IACzB,yDAAyD;AAC7D;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,cAAc;IACd,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,uBAAuB;IACvB,iBAAiB;IACjB,wBAAwB;IACxB,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,SAAS;IACT,cAAc;IACd,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,WAAW;IACX,wBAAwB;AAC5B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,yCAAyC;IACzC,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,YAAY;IACZ,UAAU;IACV,wBAAwB;IACxB,oBAAoB;IACpB,iBAAiB;IACjB,cAAc;IACd,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,aAAa;IACb,gBAAgB;IAChB,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,qCAAqC;IACrC,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,qCAAqC;IACrC,gBAAgB;IAChB,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,aAAa;IACb,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,qBAAqB;IACrB,UAAU;IACV,WAAW;IACX,wBAAwB;IACxB,6CAA6C;IAC7C,4CAA4C;AAChD;;AAEA;;;IAGI,gCAAgC;AACpC;;AAEA;IACI;QACI,kBAAkB;QAClB,YAAY;IAChB;;IAEA,UAAU;IACV,uBAAuB;IACvB,IAAI;;IAEJ;;QAEI,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;;;QAGI,gCAAgC;QAChC,aAAa;IACjB;;IAEA;;QAEI,kBAAkB;IACtB;;IAEA,yBAAyB;IACzB,oBAAoB;IACpB,mBAAmB;IACnB,IAAI;AACR;;AAEA;IACI;;;QAGI,gCAAgC;QAChC,aAAa;IACjB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;IACvB;AACJ","sourcesContent":["@value screen-sm-max, screen-md-max from '../../../../breakpoints.css';\n\n.boxOuter {\n    margin: auto 0 auto auto;\n}\n\n.fundTitle {\n    color: var(--dark-grey);\n    margin-bottom: 8px;\n}\n\n.fundTitleFN {\n    margin: 5px 0 10px 0;\n}\n\n.box {\n    width: 100%;\n    width: 370px;\n    min-width: 320px;\n    padding: 30px 10px 30px 20px;\n    background: #fbfbfc;\n    border-radius: 6px;\n    border: 4px double rgba(12, 59, 141, 0.25);\n    position: relative;\n    margin: auto;\n}\n\n.closeBtnWrapper {\n    position: absolute;\n    height: 25px;\n    width: 25px;\n    right: 14px;\n    top: 8px;\n}\n\n.closeBtnWrapper button {\n    height: 25px;\n    width: 25px;\n    padding: 0;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 1px solid var(--primary-color);\n    transition: background 0.4s;\n    --icon-color-custom: var(--primary-color);\n}\n\n.closeBtnWrapper button:hover {\n    background: var(--primary-color);\n    border-color: var(--primary-color);\n    --icon-color-custom: #fff;\n    /*--icon-fill-color-custom: var(--primary-color-active);*/\n}\n\n.closeBtnWrapper button * {\n    height: 14px;\n    width: 14px;\n    padding: 0;\n    /*display: block;*/\n    /*min-height: 25px;*/\n    /*min-width: 25px;*/\n}\n\n.fieldHeader {\n    display: flex;\n    align-items: center;\n    height: 17px;\n    color: var(--dark-grey);\n    margin-bottom: 8px;\n    text-wrap: nowrap;\n}\n\n.footnote {\n    display: inline;\n    vertical-align: super;\n    font-size: 8px;\n    padding-bottom: 10px;\n    font-weight: 400;\n}\n\n.fieldHeader .tip {\n    margin: auto auto auto 4px;\n}\n\n.tip {\n    display: inline-flex;\n    position: relative;\n    justify-content: center;\n    padding-left: 4px;\n    margin: auto 0 auto auto;\n    color: #fff;\n    font-size: 14px;\n    line-height: 18px;\n    text-transform: initial;\n    font-weight: 300;\n}\n\n.tipBtn {\n    background: transparent;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n    border: 0;\n    color: #000000;\n    font-size: 14px;\n    margin: auto;\n}\n\n.tipBtnImg {\n    position: relative;\n    display: inline-flex;\n}\n\n.tipBtn img:last-child {\n    position: absolute;\n    bottom: 0;\n    opacity: 0;\n}\n\n.tipBtn img {\n    width: 20px;\n    transition: opacity 0.4s;\n}\n\n.tipSmaller .tipBtn img {\n    width: 17px;\n}\n\n.tipBtn span:first-letter {\n    text-transform: capitalize;\n}\n\n.tip:hover img {\n    opacity: 1;\n}\n\n.tip:hover svg text {\n    fill: #fff;\n}\n\n.tip:hover .tipBox {\n    opacity: 1;\n    pointer-events: all;\n    z-index: 99;\n}\n\n.tipBox {\n    position: absolute;\n    width: 275px;\n    background: #7b848e;\n    padding: 20px;\n    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);\n    color: #fff;\n    font-size: 14px;\n    line-height: 18px;\n    margin: auto;\n    left: 50%;\n    transform: translateX(-50%);\n    bottom: 24px;\n    opacity: 0;\n    transition: opacity 0.4s;\n    pointer-events: none;\n    max-height: 200px;\n    overflow: auto;\n    z-index: -1;\n    text-align: center;\n}\n\n.tipBox:first-letter {\n    text-transform: capitalize;\n}\n\n.data {\n    display: grid;\n    row-gap: 15px;\n    column-gap: 10px;\n    grid-template-columns: repeat(2, 1fr);\n    margin-top: 15px;\n}\n\n.borderData {\n    display: grid;\n    column-gap: 10px;\n    grid-template-columns: repeat(2, 1fr);\n    padding-top: 8px;\n    padding-bottom: 8px;\n}\n\n.borderData:not(:last-child) {\n    border-bottom: 0.5px solid #707070;\n}\n\n.borderDataTop {\n    display: grid;\n    column-gap: 10px;\n    grid-template-columns: repeat(2, 1fr);\n    padding-top: 8px;\n    border-top: 0.5px solid #707070;\n    margin-top: 15px;\n}\n\n.borderDataTop h6 {\n    color: var(--dark-grey);\n}\n\n.check {\n    display: flex;\n    margin: 2px 0;\n    border: 1px solid #7b848e;\n    width: 20px;\n    min-width: 20px;\n    height: 20px;\n    border-radius: 3px;\n    transition: background-color 0.4s;\n}\n\n.check.active {\n    background: #fff;\n}\n\n.check.active:after {\n    content: '';\n    display: block;\n    margin: 3px auto auto;\n    width: 4px;\n    height: 8px;\n    transform: rotate(45deg);\n    border-bottom: 1px solid var(--primary-color);\n    border-right: 1px solid var(--primary-color);\n}\n\n.data,\n.borderData,\n.borderDataTop {\n    grid-template-columns: 150px 1fr;\n}\n\n@media screen-md-max {\n    .box {\n        padding: 30px 10px;\n        width: 320px;\n    }\n\n    /*.data {*/\n    /*    column-gap: 5px;*/\n    /*}*/\n\n    .data,\n    .borderDataTop {\n        margin-top: 16px;\n    }\n\n    .fundTitleFN {\n        margin-bottom: 16px;\n    }\n\n    .data,\n    .borderData,\n    .borderDataTop {\n        grid-template-columns: 120px 1fr;\n        row-gap: 16px;\n    }\n\n    .fieldHeader,\n    .fundTitle {\n        margin-bottom: 5px;\n    }\n\n    /*.closeBtnWrapper svg {*/\n    /*    height: 14px;*/\n    /*    width: 14px;*/\n    /*}*/\n}\n\n@media screen-sm-max {\n    .data,\n    .borderData,\n    .borderDataTop {\n        grid-template-columns: 120px 1fr;\n        row-gap: 10px;\n    }\n\n    .data,\n    .borderDataTop {\n        margin-top: 8px;\n    }\n\n    .borderData {\n        padding-top: 5px;\n        padding-bottom: 5px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen-sm-max": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-sm-max"]}`,
	"screen-md-max": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]}`,
	"boxOuter": `main-structures-detail_boxOuter__ldeO6`,
	"fundTitle": `main-structures-detail_fundTitle__EUfsr`,
	"fundTitleFN": `main-structures-detail_fundTitleFN__+o4UT`,
	"box": `main-structures-detail_box__NTyAq`,
	"closeBtnWrapper": `main-structures-detail_closeBtnWrapper__6kiol`,
	"fieldHeader": `main-structures-detail_fieldHeader__oL4+0`,
	"footnote": `main-structures-detail_footnote__hfRpO`,
	"tip": `main-structures-detail_tip__IFJRB`,
	"tipBtn": `main-structures-detail_tipBtn__WSrI1`,
	"tipBtnImg": `main-structures-detail_tipBtnImg__Gcrx+`,
	"tipSmaller": `main-structures-detail_tipSmaller__NooiI`,
	"tipBox": `main-structures-detail_tipBox__Mw33Y`,
	"data": `main-structures-detail_data__zPtg8`,
	"borderData": `main-structures-detail_borderData__bOqPt`,
	"borderDataTop": `main-structures-detail_borderDataTop__e0E5u`,
	"check": `main-structures-detail_check__csKOi`,
	"active": `main-structures-detail_active__38qFv`
};
export default ___CSS_LOADER_EXPORT___;
